export default {
  props: {
    openDialog: {
      type    : Boolean,
      default : false
    },
    title: {
      type    : String,
      default : ''
    },
    url: {
      type    : String,
      default : ''
    }
  },
  data() {
    return { };
  },
  methods: {
    close() {
      this.$emit('close-modal', false);
    }
  }
};
